// import React from "react"
import { calenderDefaultCategories, events } from "./calender";
import {chats, messages, contacts, groups} from "./chat";
import { tasks,AddTeamMember } from "./tasks";

export {
  events,
  calenderDefaultCategories,
  chats, messages, contacts, groups,
  tasks,AddTeamMember
}
